import { jsx, jsxs } from 'react/jsx-runtime';
import { font, themedColor, Box, useToggle, useCloseableElement, Flex } from '@lemonade-hq/cdk';
import { getRegion, isActiveRegion, DEFAULT_LOCALE, EN_US_LOCALE, ES_US_LOCALE, EN_GB_LOCALE, DE_DE_LOCALE, EN_DE_LOCALE, NL_NL_LOCALE, EN_NL_LOCALE, FR_FR_LOCALE, EN_FR_LOCALE, US_REGION, GB_REGION, DE_REGION, NL_REGION, FR_REGION } from '@lemonade-hq/lemonation';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import sortBy from 'lodash/sortBy';
import { useRef, useMemo, useCallback } from 'react';
import styled, { css } from 'styled-components';
import { LOCALE_URL_PREFIXES } from '../../../config/routes.esm.js';
import { Client } from '../../../helpers/client/client.esm.js';
import { getRouteForLocale } from '../../../helpers/routes.esm.js';
import { useI18nContext } from '../../../providers/I18nProvider.esm.js';
import { backgroundHoverProps } from './shared.esm.js';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  ",
        ";\n  color: ",
        ";\n  text-transform: capitalize;\n  white-space: pre;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  background-color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n    padding: 0;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  width: inherit;\n  height: 40px !important;\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: ",
        ";\n  ",
        ";\n  text-align: left;\n  outline: none;\n  padding: 0 16px;\n  ",
        ";\n\n  ",
        "\n\n  &:after {\n    content: '';\n    position: absolute;\n    top: 50%;\n    right: 16px;\n    background: transparent\n      url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAOCAYAAAAi2ky3AAAABGdBTUEAALGPC/xhBQAAASFJREFUKBVj/PHjhysDA0MmEHMBMUmAkZHxGRsbWxWQfsHy////JUDdYiSZAFUM1Mvw8+fPr0BuLhOQuE6OIUh6boDYjN+/f1cAOu0c0HRBJEmimEB9O9jZ2b2B9D8mTk7OB0BdsUDOf6J0IxQ9AhoSAzIEJATyGgMHB8dWoIvaQWxiAFDzL2Zm5lAg/RamHmwQiAM0rA4osQ8mQYAuAsbWKWQ1jMgcoKvEgMnhPFBMClkcjb0cGBxRaGIMKAaBJH///m399+/fA0BDWTAUMzJeB4aLKdDloChHAXCvwURZWVmPAtnlMD6MBmr+AsTB2AyBqcFKA724Fpg0/sMwMOFFYFVISBDoNT6gYRdABgHpTkLq8coDDWMGYnwBj1c/WZIAxqNn9YyWYw0AAAAASUVORK5CYII=')\n      no-repeat 0 0;\n    background-size: contain;\n    width: 9px;\n    height: 6px;\n    transition: transform 0.2s ease-in;\n    transform: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  height: 3.1rem;\n  ",
        ";\n  outline: none;\n  background-color: transparent;\n  border: none;\n  appearance: none;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  top: 100%;\n  left: 0;\n  border: 1px solid ",
        ";\n  border-top: none;\n  border-radius: 0 0 5px 5px;\n  background-color: ",
        ";\n  z-index: 2;\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  ",
        ";\n  ",
        ";\n  height: 40px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  display: block;\n  height: 100%;\n  text-decoration: none;\n  ",
        ";\n\n  &:hover {\n    text-decoration: none;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  height: 1.2rem;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
var expandedTransform = "translateY(-66%) translateX(-10%) rotate(180deg)";
var _obj;
var localeTitles = (_obj = {}, _define_property(_obj, EN_US_LOCALE, "\uD83C\uDDFA\uD83C\uDDF8\xa0\xa0\xa0\xa0United States"), _define_property(_obj, ES_US_LOCALE, "\uD83C\uDDFA\uD83C\uDDF8\xa0\xa0\xa0\xa0United States (Spanish)"), _define_property(_obj, EN_GB_LOCALE, "\uD83C\uDDEC\uD83C\uDDE7\xa0\xa0\xa0\xa0United Kingdom"), _define_property(_obj, DE_DE_LOCALE, "\uD83C\uDDE9\uD83C\uDDEA\xa0\xa0\xa0\xa0Germany (Deutsch)"), _define_property(_obj, EN_DE_LOCALE, "\uD83C\uDDE9\uD83C\uDDEA\xa0\xa0\xa0\xa0Germany (English)"), _define_property(_obj, NL_NL_LOCALE, "\uD83C\uDDF3\uD83C\uDDF1\xa0\xa0\xa0\xa0Netherlands (Nederlands)"), _define_property(_obj, EN_NL_LOCALE, "\uD83C\uDDF3\uD83C\uDDF1\xa0\xa0\xa0\xa0Netherlands (English)"), _define_property(_obj, FR_FR_LOCALE, "\uD83C\uDDEB\uD83C\uDDF7\xa0\xa0\xa0\xa0France (Fran\xe7ais)"), _define_property(_obj, EN_FR_LOCALE, "\uD83C\uDDEB\uD83C\uDDF7\xa0\xa0\xa0\xa0France (English)"), _obj);
var _obj1;
var localeTitlesDesktop = (_obj1 = {}, _define_property(_obj1, EN_US_LOCALE, {
    country: US_REGION,
    text: "United States"
}), _define_property(_obj1, ES_US_LOCALE, {
    country: US_REGION,
    text: "United States (Spanish)"
}), _define_property(_obj1, EN_GB_LOCALE, {
    country: GB_REGION,
    text: "United Kingdom"
}), _define_property(_obj1, DE_DE_LOCALE, {
    country: DE_REGION,
    text: "Germany (Deutsch)"
}), _define_property(_obj1, EN_DE_LOCALE, {
    country: DE_REGION,
    text: "Germany (English)"
}), _define_property(_obj1, NL_NL_LOCALE, {
    country: NL_REGION,
    text: "Netherlands (Nederlands)"
}), _define_property(_obj1, EN_NL_LOCALE, {
    country: NL_REGION,
    text: "Netherlands (English)"
}), _define_property(_obj1, FR_FR_LOCALE, {
    country: FR_REGION,
    text: "France (Fran\xe7ais)"
}), _define_property(_obj1, EN_FR_LOCALE, {
    country: FR_REGION,
    text: "France (English)"
}), _obj1);
var sharedTextStyle = css(_templateObject(), font("main", {
    fontSize: "1.4rem",
    lineHeight: "3.1rem",
    fontWeight: 700
}), themedColor("metal"));
var SelectContainer = styled(Box)(_templateObject1(), themedColor("darkestNight"));
var SelectToggle = styled.button(_templateObject3(), themedColor("darkestNight"), themedColor("night"), function(props) {
    return props.isExpanded ? "5px 5px 0 0" : "5px";
}, sharedTextStyle, backgroundHoverProps, MEDIA_QUERIES.desktop(_templateObject2()), function(props) {
    return props.isExpanded ? expandedTransform : "translateY(-50%)";
});
var Select = styled.select(_templateObject4(), sharedTextStyle);
var SelectOptions = styled(Box)(_templateObject5(), themedColor("night"), themedColor("darkerNight"), function(param) {
    var isExpanded = param.isExpanded;
    return !isExpanded && "\n        display: none;\n    ";
});
var SelectOption = styled(Box)(_templateObject6(), sharedTextStyle, backgroundHoverProps);
var LocaleLink = styled(Box)(_templateObject7(), sharedTextStyle);
var Flag = styled.img(_templateObject8());
function changeLocale(locale, url) {
    return _changeLocale.apply(this, arguments);
}
function _changeLocale() {
    _changeLocale = _async_to_generator(function(locale, url) {
        var body;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    body = {
                        locale: locale
                    };
                    return [
                        4,
                        Client.put(url, body)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return _changeLocale.apply(this, arguments);
}
var RegionLanguage = function(param) {
    var country = param.country, text = param.text;
    var s = useI18nContext().s;
    if (!country) return null;
    var url = "https://s3.amazonaws.com/lmnd-images/".concat(country.toLowerCase(), "_flag.png");
    return /*#__PURE__*/ jsxs(Flex, {
        alignItems: "center",
        gap: "12px",
        px: "16px",
        children: [
            /*#__PURE__*/ jsx(Flag, {
                alt: "".concat(s("language.select.label"), " - ").concat(text),
                src: url
            }),
            /*#__PURE__*/ jsx("span", {
                children: text
            })
        ]
    });
};
var RegionSelect = function(param) {
    var localeChangeRedirectsWithSuffixes = param.localeChangeRedirectsWithSuffixes, localeChangeUrl = param.localeChangeUrl, localeChangeLanguageOnly = param.localeChangeLanguageOnly, router = param.router;
    var selectRef = useRef(null);
    var _useI18nContext = useI18nContext(), currentLocale = _useI18nContext.locale, currentRegion = _useI18nContext.region, activeRegions = _useI18nContext.activeRegions, activeLocales = _useI18nContext.activeLocales, s = _useI18nContext.s;
    var _useToggle = useToggle(false), isOpen = _useToggle.isOpen, toggle = _useToggle.toggle, close = _useToggle.close;
    useCloseableElement(selectRef, isOpen, close);
    var options = useMemo(function() {
        return sortBy(activeLocales, function(locale) {
            return !locale.endsWith(currentRegion.toUpperCase());
        }).filter(function(locale) {
            return locale !== currentLocale;
        }).filter(function(locale) {
            return localeChangeLanguageOnly ? locale.endsWith(currentRegion.toUpperCase()) : true;
        }).map(function(locale) {
            var region = getRegion(locale);
            var url;
            if (router == null || currentRegion !== region) {
                url = "/".concat(LOCALE_URL_PREFIXES[locale]);
            } else {
                var currentPage = router.pathname.substring(1);
                url = getRouteForLocale(currentPage, locale);
            }
            return {
                locale: locale,
                url: url
            };
        });
    }, [
        activeLocales,
        currentLocale,
        currentRegion,
        localeChangeLanguageOnly,
        router
    ]);
    var onOptionsSelected = useCallback(function() {
        var _ref = _async_to_generator(function(e, selectedLocale) {
            var _options_find, url;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        return [
                            4,
                            changeLocale(selectedLocale, localeChangeUrl)
                        ];
                    case 1:
                        _state.sent();
                        url = ((_options_find = options.find(function(option) {
                            return option.locale === selectedLocale;
                        })) !== null && _options_find !== void 0 ? _options_find : {}).url;
                        window.location.href = localeChangeRedirectsWithSuffixes ? url : window.location.href;
                        return [
                            2
                        ];
                }
            });
        });
        return function(e, selectedLocale) {
            return _ref.apply(this, arguments);
        };
    }(), [
        localeChangeRedirectsWithSuffixes,
        localeChangeUrl,
        options
    ]);
    var baseLocaleTitle = localeTitles[isActiveRegion(currentLocale, activeRegions) ? currentLocale : DEFAULT_LOCALE];
    var baseLocaleTitleDesktop = localeTitlesDesktop[isActiveRegion(currentLocale, activeRegions) ? currentLocale : DEFAULT_LOCALE];
    return /*#__PURE__*/ jsx(Flex, {
        flexDirection: "column",
        order: [
            2,
            1,
            1
        ],
        width: "100%",
        children: /*#__PURE__*/ jsxs(SelectContainer, {
            ref: selectRef,
            width: [
                "100%",
                258
            ],
            children: [
                /*#__PURE__*/ jsx(Box, {
                    display: [
                        "block",
                        "none"
                    ],
                    width: "100%",
                    children: /*#__PURE__*/ jsx(SelectToggle, {
                        children: /*#__PURE__*/ jsxs(Select, {
                            "aria-label": s("language.select.label"),
                            id: "region-select",
                            onChange: function(e) {
                                void onOptionsSelected(e, e.target.value);
                            },
                            value: currentLocale,
                            children: [
                                /*#__PURE__*/ jsx("option", {
                                    value: currentLocale,
                                    children: baseLocaleTitle
                                }),
                                options.map(function(param) {
                                    var locale = param.locale;
                                    return /*#__PURE__*/ jsx("option", {
                                        value: locale,
                                        children: localeTitles[locale]
                                    }, locale);
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ jsxs(Box, {
                    display: [
                        "none",
                        "block"
                    ],
                    width: "100%",
                    children: [
                        /*#__PURE__*/ jsx(SelectToggle, {
                            "aria-haspopup": "listbox",
                            "aria-label": s("language.select.label"),
                            isExpanded: isOpen,
                            onClick: toggle,
                            children: /*#__PURE__*/ jsx(RegionLanguage, _object_spread({}, baseLocaleTitleDesktop))
                        }),
                        /*#__PURE__*/ jsx(SelectOptions, {
                            "aria-labelledby": "toggle-label",
                            as: "ul",
                            isExpanded: isOpen,
                            role: "listbox",
                            width: 1,
                            children: options.map(function(param) {
                                var locale = param.locale, url = param.url;
                                return /*#__PURE__*/ jsx(SelectOption, {
                                    "aria-selected": "false",
                                    as: "li",
                                    role: "option",
                                    children: /*#__PURE__*/ jsx(LocaleLink, {
                                        as: "a",
                                        href: localeChangeRedirectsWithSuffixes ? url : window.location.href,
                                        onClick: function(e) {
                                            void onOptionsSelected(e, locale);
                                        },
                                        px: "8px",
                                        width: 1,
                                        children: /*#__PURE__*/ jsx(RegionLanguage, _object_spread({}, localeTitlesDesktop[locale]))
                                    })
                                }, locale);
                            })
                        })
                    ]
                })
            ]
        })
    });
};

export { RegionSelect };
